<div class="communications-container">
  <div class="header">
    <h1>Comunicados</h1>
    @if (isOwner) {
      <button mat-raised-button color="primary" (click)="openCreateDialog()">
        <mat-icon>add_comment</mat-icon>
        Adicionar comunicado
      </button>
    }
  </div>

  @if (communications.length === 0) {
    <div class="no-communications">
      <p>Nenhum comunicado</p>
    </div>
  }

  @if (communications.length > 0) {
    <div class="communications-list">
      @for (communication of communications; track communication) {
        <mat-card class="communication-card" (click)="navigateToDetails(communication.id)">
          @if (isOwner) {
            <div class="delete-button">
              <button mat-icon-button color="warn" (click)="openDeleteDialog(communication)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
          <mat-card-header>
            <mat-card-title>{{ communication.title }}</mat-card-title>
            <mat-card-subtitle>{{ communication.createDate | date:'dd/MM/yyyy HH:mm' }}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p style="white-space: pre-line">{{ communication.body }}</p>
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  @if (communications.length > 0) {
    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="onPageChange($event)"
      aria-label="Selecione a página">
    </mat-paginator>
  }
</div>